var globalRouter;
var Bootstrap = (function()
{
    require.config({
        baseUrl: './app',
        paths: {
            text:  '../../lib/require-plugins/text',               // Require.js plugin "text"
            json:  '../../lib/require-plugins/json',               // Require.js plugin "json"
            order: '../../lib/require-plugins/order',              // Require.js plugin "order"
            domReady: '../../lib/require-plugins/domReady',        // Require.js plugin "order"

            loader:     '../../lib/loader',                        // jQuery, Underscore, Backbone, LESS Libs
            config:     'config/config',                           // Main application config module
            helper:     '../../core/Helper',                       // Common methods
            sandbox:    '../../core/Sandbox',                      // Public core methods

			mainRouter:  'router'                                   // Main router
        }
    });

    require(
        [
            'loader',
            'domReady',
			'mainRouter'
        ],
        function(Loader, domReady, Router)
        {
            Loader.Backbone.$ = Loader.$;

            domReady(function(){
                globalRouter = Router;
                globalRouter.init();
            });
        }
    );


})();
define("bootstrap", function(){});

